export default __webpack_public_path__ + "static/consulting-2-cb6ff601fb69576d327451ae7c60c78a.jpg";